import http from './httpService';
import {encodeQueryData} from '../../Utils/Common';
const API_URL_PTS = process.env.REACT_APP_API_URL_PTS;

async function getPtsData(params:any) {
    const url = `${API_URL_PTS}geptsdata?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

const PtsServices = {
    getPtsData,
};

export default PtsServices;